import { useParams } from 'react-router-dom';

import AddMyApp from '@components/template/appManage/myApp';
import AddCompetitorsApp from '@components/template/appManage/competitorsApp';

const MyAppManager = () => {
  // 아래의 params 값으로 분기 처리하여 myApp 등록 step 을 거친다
  // step1 : addMyApp
  // step2 : addCompetitorsApp
  // step3 : /myApps 로 돌아오기 (등록한 목록 가져오기)
  const { step } = useParams();
  console.log('step: ', step);
  return (
    <>
      {/* addMyApp */}
      {step === 'addMyApp' && <AddMyApp />}
      {/* addCompetitorsApp */}
      {step === 'addCompetitorsApp' && <AddCompetitorsApp />}
    </>
  );
};

export default MyAppManager;
